import React, { FC, useMemo } from 'react';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import InfoWithKeyValuePair from '../supplier_assets_detail_page/InfoWithKeyValuePair';
import PRQuantityDisplay from './PRQuantityDisplay';
import POQuantityDisplay from './POQuantityDisplay';

const QuantityOnOrderDisplay: FC<any> = ({ ppsl }): React.ReactElement => {
	const quantityOnOrder = useMemo(
		() =>
			nullSafeGetOrElse('purchaseRequestQuantity', ppsl, 0) +
			nullSafeGetOrElse('purchaseOrderQuantity', ppsl, 0),
		[ppsl]
	);

	const details = useMemo(
		() => ({
			...(nullSafeGetOrElse('purchaseRequestQuantity', ppsl, 0) && {
				'PR Qty': (
					<PRQuantityDisplay
						quantity={nullSafeGetOrElse('purchaseRequestQuantity', ppsl, 0)}
						stockLocationId={ppsl.stockLocationId}
						partId={ppsl.partId}
					/>
				),
			}),
			...(nullSafeGetOrElse('purchaseOrderQuantity', ppsl, 0) && {
				'PO Qty': (
					<POQuantityDisplay
						quantity={nullSafeGetOrElse('purchaseOrderQuantity', ppsl, 0)}
						stockLocationId={ppsl.stockLocationId}
						partId={ppsl.partId}
					/>
				),
			}),
		}),
		[ppsl]
	);

	return (
		<div className="flex flex-row items-center">
			<div>{quantityOnOrder}</div>
			{quantityOnOrder ? (
				<div className="ml-2">
					<InfoWithKeyValuePair details={details} />
				</div>
			) : null}
		</div>
	);
};

export default QuantityOnOrderDisplay;
